<script>

import SliderPhoto from '@/components/slider-photo';
import catalog from '@/mixins/catalog';


export default {name:"one-project",

                        props: [
                                'item',
                                'path',
                                'isPlaying'
                            ],
                        components:{"slider-photo": SliderPhoto},
                        mixins:[catalog],
                        data:function(){

                            return {
                                        
                                                            
                                    }
						
                        },
                        mounted() {
                            
                           

                        },

                        created: function(){

           
                            //console.log(this.maxHeight);

                        }, 

                        computed: {
							
							
                        },
						methods:{

                            getPath(img)
                            {
                                return this.path+"/images/"+img;
                            }
						
						}

					}

</script>

<template>
    
    <div class="slider-built-cottages__item">
    <a :href="item.DETAIL_PAGE_URL" class="">
                                    <div class="cottages__images-img">
                                        
                                            <slider-photo :item="item" :max-height="174" :is-playing="isPlaying"></slider-photo>
                                       
                                           
                                       
                                    </div>
                                    <div class="built-cottage__content-wrapper">
                                        <div class="built-cottage__content">
                                            <p class="built-cottage__content-title">
                                                <a :href="item.DETAIL_PAGE_URL">{{item.NAME}}</a>
                                            </p>
                                            <p class="projects-home__note">
                                                Построим на выбраном вами участке
                                            </p>
                                            <p class="built-cottage__price" v-if="checkPrice(item)">от {{parseInt(item.PROPS.PRICE[0].VALUE) | currency}}</p>
                                        </div>
                                        <div class="built-cottage__details">
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Спальни:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.ROOMS[0].VALUE}}</div>
                                            </div>
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Санузлов:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.BATHROOMS[0].VALUE}}</div>
                                            </div>
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Этажей:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.FLOORS[0].VALUE}}</div>
                                            </div>
                                            <div class="built-cottage__detail">
                                                <p class="built-cottage__details-name">Площадь:</p>
                                                <div class="built-cottage__details-count">{{item.PROPS.M2[0].VALUE}} м²</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="built-cottage__info">
                                        <p class="project-check">Проект дома</p>
                                        <div class="house-icons">
                                            <button class="house-icon__btn">
                                                <img class="house-icon__img house-icon__img-add house-icon-compare-cor"
                                                :src="getPath('icone-favourite-add.svg')" alt="Icon">
                                            </button>
                                            <button class="house-icon__btn">
                                                <img class="house-icon__img" :src="getPath('icon-heart.svg')" alt="Icon">
                                            </button>
                                        </div>
                                    </div>
    </a>
    </div>
    
</template>  


